export default __webpack_public_path__ + "static/media/circle.70d08439.png";